export default __webpack_public_path__ + "static/media/avatar_default.1a218be3.jpg";